@if(dropdownType == 'simple') {
    <div class="dropdown icon-dropdown" ngbDropdown>
        <button class="btn dropdown-toggle" type="button" ngbDropdownToggle>
            <i class="icon-more-alt"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @for(option of options; track option) {
                <a class="dropdown-item" href="javascript:void(0)" (click)="selectItem(option.title)" ngbDropdownItem>{{ option.title }}</a>
            }
        </div>
    </div>
} @else if(dropdownType == 'classic') {
    <div class="dropdown" [ngClass]="dropdownClass" ngbDropdown>
        <button class="btn dropdown-toggle" type="button" ngbDropdownToggle>{{ selectedItem }}</button>
        <ul class="dropdown-menu" ngbDropdownMenu>
            @for(option of options; track option) {
                <li ngbDropdownItem>
                    <a class="dropdown-item" href="javascript:void(0)" (click)="selectItem(option.title)">{{ option.title }}</a>
                </li>
            }
        </ul>
    </div>
}
